import en from './en';
import fr from './fr';
import nl from './nl';


export default {
    en: {
        message: en
    },
    fr: {
        message: fr
    },
    nl: {
        message: nl
    }
}